import React from 'react';
import '../styles/AboutSection.css';
import InteractiveHoverButton from './InteractiveHoverButton';

function AboutSection() {
  return (
    <section className="about-section">
      <div className="about-container">
        <h3 className="section-title">About <span className="letter-blue">e</span>
          <span className="letter-red">k</span>
          <span className="letter-blue">s</span>
          <span className="letter-blue"> construction</span></h3>
        <div className="about-content">
          <p className="about-text">
            We are <span className="about-highlight"><span className="letter-blue">e</span>
              <span className="letter-red">k</span>
              <span className="letter-blue">s</span>
              <span className="letter-blue"> construction</span></span>, one of Chennai's leading companies.
            Our construction and renovation packages start from just <span className="price-highlight">₹2,099</span>,
            tailored to fit different budget levels while ensuring top-tier, industry-standard quality.
          </p>
        </div>

        {/* Know More Button */}
        <div className="about-cta">
          <InteractiveHoverButton
            text="Explore packages"
            href="https://eksconstruction.in/packages"
          />
        </div>
      </div>
    </section>
  );
}

export default AboutSection;